// extracted by mini-css-extract-plugin
module.exports = {"wrap":"kakao_wrap__3iPSV","btn":"kakao_btn__1Sa0R"};